import { createAction } from '@ngrx/store';

const load = createAction('[Professional Details teams] Load teams and professionals');

export const ProfessionalDetailsActions = {
  load: load,
};
